import React, { useEffect, useState, Fragment } from 'react';
import { format, parseISO, fromUnixTime, formatDistanceToNow } from 'date-fns';
  
const Transaction_Row = ({
    ad_details
}) =>  {

    const [adBudget, setAdBudget] = useState(null);
    const [adSpend, setAdSpend] = useState(null);

    useEffect(() => {
        if (!ad_details) return;
    
        const amount_budgeted = (ad_details.budget.amount_budgeted / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        const total_spent = (ad_details.budget.total_spent / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        setAdBudget(amount_budgeted);
        setAdSpend(total_spent);
    }, [ad_details]);

	return (
        <div style={{width: '100%', display: 'flex', padding: '20px 0', borderBottom: '1px solid #e6ecf0'}}>
            <div style={{flex: 1}}>
                <span style={{fontSize: '15px'}}>{format(ad_details.date, "MMM d, yyyy")}</span>
            </div>
            <div style={{flex: 1}}>
                {ad_details ? (
                    <Fragment>
                        {(ad_details?.status === 'checkout' || ad_details?.status === 'scheduled' || ad_details?.status === 'in review') ? (
                            <span style={{fontSize: '15px'}}>-- of {adBudget}</span>
                        ) : (
                            <span style={{fontSize: '15px'}}>
                                {adSpend} of {adBudget}
                            </span>
                        )}

                    </Fragment>
                ) : (
                    <span style={{fontSize: '15px'}}>--</span>
                )}
            </div>
            <div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>
                {ad_details?.status === 'active' && (
                    <div style={{background: '#D4EDDA', color: '#155724', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Running
                    </div>
                )}
                {ad_details?.status === 'paused' && (
                    <div style={{background: '#E2E3E5', color: '#383D41', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Paused
                    </div>
                )}
                {ad_details?.status === 'in review' && (
                    <div style={{background: '#FFF3CD', color: '#856404', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        In Review
                    </div>
                )}
                {ad_details?.status === 'rejected' && (
                    <div style={{background: '#F8D7DA', color: '#721C24', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Rejected
                    </div>
                )}
                {ad_details?.status === 'stopped' && (
                    <div style={{background: '#D1ECF1', color: '#0C5460', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Stopped
                    </div>
                )}
                {ad_details?.status === 'checkout' && (
                    <div style={{background: '#FFF3CD', color: '#856404', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Not Paid
                    </div>
                )}
                {ad_details?.status === 'scheduled' && (
                    <div style={{background: '#E2E3E5', color: '#383D41', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Scheduled
                    </div>
                )}
                {ad_details?.status === 'completed' && (
                    <div style={{background: '#333', color: '#fff', fontWeight: 500, width: 'fit-content', fontSize: '12px', height: 'fit-content', borderRadius: '5px', padding: '5px'}}>
                        Completed
                    </div>
                )}
            </div>
        </div>
	);
}
  
export default Transaction_Row;
  